import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const DeleteLoyaltyConfigModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete Config"
      bodyMessage="Are you sure you want to delete this config?"
    />
  );
};

export default DeleteLoyaltyConfigModal;